/**
 * Picks the first candidate that is actually a usable image URL.
 *
 * The distinction that matters is blank-vs-absent. `??` only falls through on
 * `null`/`undefined`, so an API that reports "no picture set" as `""` — which the
 * IAM user list does for users without one — beat every fallback the caller
 * supplied and left the avatar with `uri: ""`. That renders nothing at all: not
 * the image, not the initials placeholder, just an empty circle.
 */
export const firstUsableImageUrl = (
  ...candidates: readonly (string | null | undefined)[]
): string | null => {
  for (const candidate of candidates) {
    if (typeof candidate !== "string") continue;
    const trimmed = candidate.trim();
    // "undefined"/"null" show up when a URL is built by string interpolation
    // over a missing value; they are never real URLs.
    if (!trimmed || trimmed === "undefined" || trimmed === "null") continue;
    return trimmed;
  }
  return null;
};
